module.exports = __webpack_public_path__ + "static/dorota-c6fb8d4876301b4c67bb416e59c5593c.png";